export default function initHeaderQuizz() {
    const $headerQuizz = document.querySelectorAll<HTMLElement>('.block-header-quizz');
    $headerQuizz.forEach($container => {
        new HeaderQuizz($container);
    });
}

class HeaderQuizz {
    $el: HTMLElement;
    $btnStartQuizz: HTMLButtonElement | null;
    $iframeGenially: HTMLElement | null;
    $push: HTMLElement | null;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.$btnStartQuizz = this.$el.querySelector('.header-push-cta');
        this.$iframeGenially = this.$el.querySelector('.iframe-genially');
        this.$push = this.$el.querySelector('.header-push');
        this.init();
    }

    init() {
       this.$btnStartQuizz?.addEventListener('click', () => {
        this.$push?.classList.add('hidden');
        this.$iframeGenially?.classList.add('visible');
       });
    }
}
